import React, { Component } from 'react'
import NumberFormat from 'react-number-format';
import { faTrashAlt } from '@fortawesome/free-regular-svg-icons'

export default class Broker extends Component {
    constructor(props) {
        super(props);
        this.state={
            contextmenu:false,
            contextData:[{title:'آرشیو',icon:faTrashAlt}],
            showContext:false,
            hideDialog:false,
            modalShow:false,
        }

        this.conmenu = React.createRef();

        this.buttons = [{
                buttonModel: {
                    content: 'بله',
                    cssClass: 'e-flat',
                    isPrimary: true,
                },
                'click': () => {
                    this.setState({ hideDialog: false });
                }
                },
                {
                    buttonModel: {
                        content: 'خیر',
                        cssClass: 'e-flat'
                    },
                    'click': () => {
                        this.setState({ hideDialog: false });
                    }
        }];
        

        
        // this.contextSelect = this.contextSelect.bind(this);

        this.btnClick = this.btnClick.bind(this);
    }


    btnClick() {
        this.conmenu.current.showMenu(this.targett.getBoundingClientRect().bottom+"px",this.targett.getBoundingClientRect().left+"px");
    }

    // contextSelect = (args) => {

    // };

    menuClicked(title){
        if (title==='آرشیو'){
            this.props.archiveBroker();
        } else if (title==='ویرایش'){
            this.props.editBroker();
        }
    }

    hideVideo(){
        this.setState({ modalShow: false });
    }

    render() {
        return (
            <div className={!this.props.selected ? "brokerItem":"brokerItemSelect"} style={this.props.isLast?{marginLeft:'0px'}:null} onClick={this.props.clicked}>
                <div className="brokerLogo"><img src={this.props.logo} alt="Logo"/></div>
                <div className="brokerInfo">
                    <div style={{display:'flex',flexDirection:'column',fontSize:'12px'}}>
                        <div title={this.props.name} style={!this.props.selected ? {color:'var(--textcolor1)'}:{color:'white'}}>{this.props.name}</div>
                        <div style={!this.props.selected ? {color:'var(--gray1)',fontSize:'10px'}:{color:'white',fontSize:'10px'}}>{this.props.lable}</div>
                    </div>
                    <div style={{color:this.props.price>0?"var(--green1)":this.props.price===0?"var(-gray1)":"var(--red1)",direction:'ltr',display:'flex',flexDirection:'row-reverse',fontSize:'12px'}}><NumberFormat allowNegative={true} value={this.props.price} displayType={'text'} thousandSeparator={true} /> ریال&nbsp;</div>
                </div>
            </div>
        )
    }
}
